'use client'
import type { AnnualReportContentWithImage } from '@/.generated/sanityTypes/graphql'
import { useLocale } from 'next-intl'
import type { Locale } from '@/i18n'
import { cx } from '@monorepo/helper/cx'
import { withNewLines } from '@/lib/newline'
import { getTheme } from '@/lib/theme'
import { LocalizedImage } from '@/components/Image'

const ContentWithImageBlock = ({
  title,
  content,
  imageDesktop,
  imageMobile,
  colorlist,
}: AnnualReportContentWithImage) => {
  const locale = useLocale() as Locale
  const theme = getTheme(colorlist)

  const imgMob = imageMobile?.[locale] ?? imageMobile?.de

  return (
    <div
      className={cx(
        'relative m-auto flex flex-col justify-center gap-10 text-center',
        (title || content) && 'py-10',
        theme.bg,
        theme.text,
      )}
    >
      {title && (
        <div className="mb-2 flex justify-center">
          <h2
            className={cx(
              'max-w-screen-xl px-20 text-lg font-medium md:text-3xl md:leading-10 lg:px-0',
              theme.headline,
            )}
          >
            {withNewLines(title?.[locale])}
          </h2>
        </div>
      )}

      <LocalizedImage
        localeImage={imageDesktop}
        className={cx('!w-screen', imgMob?.asset ? 'hidden md:block' : 'block')}
      />
      <LocalizedImage
        localeImage={imageMobile}
        className="block !w-screen md:hidden"
      />
      {content && (
        <div className="flex justify-center">
          <p className="max-w-screen-xl px-6 text-lg font-light md:text-3xl md:leading-10 lg:px-0">
            {content[locale]}
          </p>
        </div>
      )}
    </div>
  )
}

export default ContentWithImageBlock
